<template>
    <div class="Listing__HeaderButtons">
        <div class="row middle-xs">
            <div class="col-sm-6 col-xs-12">
                <a href="#" class="Header__Navigation Header__Navitem" @click="toSearchList"><i class="fas fa-arrow-left"></i>{{'Back to all properties' | language}}</a>
            </div>
            <div class="col-sm-6 end-sm col-xs-12">
                <el-button type="text" class="lang-btn" v-if="$store.state.general.language === 'english'" @click.native="language('japanese')">
                    日本語
                </el-button>
                <el-button type="text" class="share-btn" v-if="$store.state.general.language === 'japanese'" @click.native="language('english')">
                    English
                </el-button>
                <el-button type="text" size="mini" class="fav-btn"  v-if="!loading">
                    <img :src="require('../../assets/images/jhf_fav_col.svg')" @click="favorite" class="Listing__HeaderButtonFavorite" v-if="utils.isFavorite(property.int_property_id, $store.state.user.favoriteIds)">
                    <img :src="require('../../assets/images/jhf_fav_bw.svg')" @click="favorite" class="Listing__HeaderButtonFavorite" v-else>
                    <span>{{'Favorite' | language}}</span>
                </el-button>
                <i class="fas fa-spinner fa-spin" v-else></i>
                <el-dropdown>
                    <el-button type="text" size="mini" class="share-btn">
                        <i class="fas fa-share-alt"></i>{{'Share' | language}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" class="share-dropdown">
                        <el-dropdown-item>
                            <social-sharing url="https://japanhomefinder.com/" inline-template>
                                <network network="facebook">
                                    <i class="fab fa-facebook-f"></i>
                                    Facebook
                                </network>
                            </social-sharing>
                        </el-dropdown-item>
                        <el-dropdown-item @click.native = "sendMail">
                                    <i class="fas fa-envelope-open-text"></i>
                                    Email
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <social-sharing url="https://vuejs.org/" inline-template>
                                <network network="twitter">
                                    <i class="fab fa-twitter"></i>
                                    Twitter
                                </network>
                            </social-sharing>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="text" icon="el-icon-printer" @click="print" v-if="!printLoading" class="share-btn">{{'Print' | language}}</el-button>
                <i class="fas fa-spinner fa-spin" v-else></i>
            </div>
        </div>
    </div>
</template>

<script>
    import LoginModal from '../Pages/Login/Modal'
    import utils from '../../services/utilsService.js'
    import config from '../../../config'


    export default {
        name: 'listing-header',
        props: {
            property: Object
        },
        computed: {
            isLoggedIn() {
                return this.$store.getters['user/isLoggedIn']
            }
        },
        data(){
            return{
                utils: utils,
                loading: false,
                config: config,
                printLoading: false
            }
        },
        methods: {
            toHome() {
                this.$router.push({
                    path: '/',
                    query: {}
                })
            },
            toSearchList() {
               this.$router.push({path: '/properties', query: this.$store.state.search.query})
            },
            beforeOpen() {
            },
            beforeClose() {
               this.$store.dispatch('property/properties',this.$route.query)
            },
            favorite() {
                const that = this
                that.loading = true
                const promise = this.$store.dispatch('property/favorite',this.property.int_property_id);
                promise.then(() => {
                    this.$store.dispatch('user/favorites')
                    const getMePromise = this.$store.dispatch('user/getFavoriteIds')
                    getMePromise
                    .finally(() => {
                        that.loading = false
                    })
                })
                .catch(() => {
                    that.loading = false
                    this.$modal.show(LoginModal, {
                    }, {
                        name: 'login-modal',
                        width: '100%',
                        maxWidth: 350,
                        height: 'auto',
                        adaptive: true,
                        scrollable: true,
                    }, {
                        'before-open': this.beforeOpen,
                        'before-close': this.beforeClose
                    })
                })
            },
            sendMail(){
                const email = this.config.INQUIRE_EMAIL
                const subject = 'Id:' + this.property.int_property_id + ' Name: '+ this.property.str_property_name_en
                window.open('mailto:'+ email + '?subject=' + subject);
            },
            print(){
                this.printLoading = true
                const params = {
                    id: this.property.int_property_id,
                    language: this.$store.state.general.language
                }
                this.$store.dispatch('property/print',params)
                .then(resp => {
                    this.forceFileDownload(resp)
                })
                .catch(resp => {
                        this.$message({
                        showClose: true,
                        message: 'Error Happen, Please try it later',
                        type: 'error'
                    });
                })
                .finally(() => {
                    this.printLoading = false
                })
            },
               forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', this.property.str_property_name_en + '.pdf') //or any other extension
                document.body.appendChild(link)
                link.click()
                 this.$message({
                    showClose: true,
                    message: 'Downloaded Successfully',
                    type: 'success'
                });
            },
            language(value) {
                this.$store.commit('general/set_language', value);
            }
        }
    }
</script>

<style lang="scss">
    .Listing__HeaderButtons {
        width: 100%;
        margin: 1em 0;
        border-bottom: 1px solid rgba($alternate-color, .2);
        padding-bottom: .5em;

        .fav-btn {
            vertical-align: middle;

            span {
                display: inline-block;
                vertical-align: middle;
            }
        }

        .Listing__HeaderButtonFavorite {
            width: 20px ;
            height: 20px;
            vertical-align: middle;
            display: inline-block;
            margin-right: .75em;
        }

        .fas {
            margin-right: .75em;
            padding-right: 0;
            font-size: 14px;
        }
    }

    .el-button.share-btn {
        margin-left: 2em;
        vertical-align: middle;
    }

    .share-dropdown {
        .fas, .fab {
            width: 20px;
        }
    }

    .v--modal-overlay {
        z-index: 9999 !important;
    }
</style>


